export default __webpack_public_path__ + "static/media/finger.ecca1a97.gif";